// this is an autogenerated file from DesignSystem/DataVaxiomOtherProfessionalsRelationshipsItem/Menu/Option/mutation-remove-hub-access.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_DataVaxiomOtherProfessionalsRelationshipsItem_Menu_Option($user_id: uuid!) {
  update_users_by_pk(pk_columns: { id: $user_id }, _set: { account_id: null }) {
    id
    account_id
    account {
      id
    }
  }
}

`